import React, { useState } from 'react';

// Components
import WpToastManager from '../WpToastManager';
import { WpButton, WpButtonGroup } from '../../button';

const ToastDocs = () => {
  const [toastInput, setToastInput] = useState('');
  const [actionBtnLabel, setActionBtnLabel] = useState('');
  const [autoDismiss, setAutoDismiss] = useState(true);
  const [showDismissBtn, setShowDismissBtn] = useState(true);

  const toggleAutoDismiss = () => {
    setAutoDismiss(!autoDismiss);
  };

  const toggleShowDismissButton = () => {
    setShowDismissBtn(!showDismissBtn);
  };

  const handleToastActionBtnClick = () => {
    alert('action button callback');
  };

  const toastClick = variant => {
    WpToastManager.addToast(toastInput || variant, {
      options: {
        variant,
        autoDismiss,
        showDismissBtn,
        actionBtnLabel,
        actionBtnFnc: handleToastActionBtnClick,
      },
    });
    setToastInput('');
  };

  return (
    <>
      <input
        className="mb-4"
        value={toastInput}
        onChange={e => setToastInput(e.target.value)}
        placeholder="toast message"
      />
      <div className="d-flex flex-column">
        <div>
          <input
            type="checkbox"
            id="autoDismiss"
            name="autoDismiss"
            checked={autoDismiss}
            onChange={toggleAutoDismiss}
          />
          <label htmlFor="autoDismiss" className="ml-2">
            {' '}
            autoDismiss toast (default true)
          </label>
        </div>
        <div>
          <input
            type="checkbox"
            id="showDismiss"
            name="showDismiss"
            checked={showDismissBtn}
            onChange={toggleShowDismissButton}
          />
          <label htmlFor="showDismiss" className="ml-2">
            {' '}
            showDismiss button (default true)
          </label>
        </div>
        <p className="mb-0 mt-2 text-muted">action button label</p>
        <input
          style={{ width: '150px' }}
          className="mb-4"
          value={actionBtnLabel}
          onChange={e => setActionBtnLabel(e.target.value)}
          placeholder="ex: 'Undo' or 'View'"
        />
      </div>
      <WpButtonGroup>
        <WpButton onClick={() => toastClick('info')}>info</WpButton>
        <WpButton onClick={() => toastClick('success')}>success</WpButton>
        <WpButton onClick={() => toastClick('warning')}>warning</WpButton>
        <WpButton onClick={() => toastClick('danger')}>danger</WpButton>
      </WpButtonGroup>
      <h5 className="mt-3">Using explicit helper functions </h5>
      <p className="text-muted">example: `WpToastManager.success(&quot;Success message here&quot;);` </p>
      <WpButtonGroup>
        <WpButton
          onClick={() =>
            WpToastManager.info('WpToastManager.info', {
              autoDismiss,
              showDismissBtn,
              actionBtnLabel,
              actionBtnFnc: handleToastActionBtnClick,
            })
          }
        >
          info
        </WpButton>
        <WpButton
          onClick={() =>
            WpToastManager.success('WpToastManager.success', {
              autoDismiss,
              showDismissBtn,
              actionBtnLabel,
              actionBtnFnc: handleToastActionBtnClick,
            })
          }
        >
          success
        </WpButton>
        <WpButton
          onClick={() =>
            WpToastManager.warning('WpToastManager.warning', {
              autoDismiss,
              showDismissBtn,
              actionBtnLabel,
              actionBtnFnc: handleToastActionBtnClick,
            })
          }
        >
          warning
        </WpButton>
        <WpButton
          onClick={() =>
            WpToastManager.danger('WpToastManager.danger', {
              autoDismiss,
              showDismissBtn,
              actionBtnLabel,
              actionBtnFnc: handleToastActionBtnClick,
            })
          }
        >
          danger
        </WpButton>
      </WpButtonGroup>
    </>
  );
};

export default ToastDocs;
